// Queries
import defaultRateTable from "./DefaultRateTableQuery.gql";
import rateTables from "./RateTablesQuery.gql";
import zipCodeRates from "./ZipCodeRatesQuery.gql";

export const Query = {
    zipCodeRates,
    rateTables,
    defaultRateTable,
};
